import { Form, Formik } from "formik";
import React, { useContext, useRef } from "react";
import SidebarField from "../../../Components/SidebarField";
import Lable from "../../../Components/Lable";
import { LuEye } from "react-icons/lu";
import { MdDownloadDone, MdOutlineShoppingCart } from "react-icons/md";
import { PiShareFat } from "react-icons/pi";
import { Line } from "react-chartjs-2";
import Button from "../../../Components/Button";
import { toast } from "react-toastify";
import LoaderContext from "../../../Components/loader";
import { approvalStatusApi } from "../../../App/api/multilevelApproval.api";
import ApprovalFlowManager from "../ApprovalFlowManager";
import ApprovalStatus from "../ApprovalStatus";

const AdvertisementModal = ({
  isAdvertisementModel,
  selectedOrder,
  onClose,
  action,
  approvalStatus,
  getAllAdvertise,
  setIsAdvertisementModel,
}) => {
  const chartRef = useRef(null);
  const { handleLoading } = useContext(LoaderContext);

  const data = {
    labels: ["January", "February", "March", "April", "May", "June", "July"],
    datasets: [
      {
        label: "Views",
        data: [35000, 22000, 80000, 15000, 56000, 11000, 40000],
        backgroundColor: "rgba(72, 187, 120, 0.2)",
        borderColor: "rgba(72, 187, 120, 1)",
        tension: 0.4,
      },
      {
        label: "Orders",
        data: [32000, 32000, 10000, 95000, 19000, 11800, 10000],
        backgroundColor: "rgba(255, 99, 132, 0.2)",
        borderColor: "rgba(255, 99, 132, 1)",
        tension: 0.4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: { display: false },
      },
      y: {
        grid: { color: "#e0e0e0" },
        ticks: { beginAtZero: true },
      },
    },
  };

  const {
    approvalLevel,
    ApprovalFlow,
    matchedData,
    waitingForApproval,
    allApprovals,
    validateAndApprove,
  } = ApprovalFlowManager({
    component: "Advertisement", // Dynamic Component Type
    currentItems:selectedOrder,
    approvalStatus,
  });
  const handleSubmit = async () => {
    handleLoading(true);
    const payload = {
      component_id: selectedOrder?._id,
      component: "Advertisement",
      approvalFlow: allApprovals?.data?.[0]?._id,
      progress: {
        level: approvalLevel?.level,
        user: approvalLevel?.user,
        status: action,
        remarks: "",
      },
    };

    if (!validateAndApprove(payload)) {
      handleLoading(false);
      return;
    }

    try {
      ApprovalFlow?.length > 0
        ? await approvalStatusApi.updateApprovalStatus(
            payload,
            ApprovalFlow?.[0]?._id
          )
        : await approvalStatusApi.createApprovalStatus(payload);
      handleLoading(false);
      toast.success(`Advertisement ${action} by ${approvalLevel?.level}!`);
      getAllAdvertise();
      setIsAdvertisementModel(false);
    } catch (error) {
      toast.error(error?.message);
      handleLoading(false);
    }
  };

  return (
    <div>
      {isAdvertisementModel && (
        <Formik
          initialValues={{
            image: selectedOrder?.image || "",
            advertisement_for: selectedOrder?.advertisement_for || "product",
            product: selectedOrder?.product || null,
            start_date: selectedOrder?.start_date || "",
            end_date: selectedOrder?.end_date || "",
            audience_type: selectedOrder?.audience_type || "",
            target_audience_age: selectedOrder?.target_audience_age || 0,
            location_radius: selectedOrder?.location_radius || 0,
            gender: selectedOrder?.gender || "All",
            advertisement_budget: selectedOrder?.advertisement_budget || 0,
            advertisement_tax: selectedOrder?.advertisement_tax || 0,
            advertise_views: selectedOrder?.advertise_views || 0,
            ordered_by_advertise: selectedOrder?.ordered_by_advertise || 0,
            addToCart_count: selectedOrder?.addToCart_count || 0,
            share: selectedOrder?.share || 0,
          }}
        >
          {({ values }) => (
            <Form>
              <SidebarField
                handleClose={onClose}
                title_style="text-2xl font-semibold text-gray-800"
                title="Advertisement Details"
                button1={<Button text="Back" type="button" onClick={onClose} />}
                button2={
                  <Button
                    disable={
                      ApprovalFlow?.[0]?.progress?.status === "Approved"
                        ? "disabled"
                        : ""
                    }
                    text={
                      ApprovalFlow?.[0]?.progress?.status === "Approved"
                        ? "Approved"
                        : "Approve"
                    }
                    onClick={handleSubmit}
                    type="submit"
                  />
                }
                // button0={<Button}
              >
                <div className="p-4">
                  {/* Promo Image */}
                  <div className="relative h-60 w-full shadow-md rounded-lg overflow-hidden">
                    <img
                      src={values.image || "https://via.placeholder.com/300"}
                      alt="Promo"
                      className="object-cover w-full h-full"
                    />
                  </div>

                  {/* Advertisement Details */}
                  <div className="mt-6">
                    <div className="flex justify-between items-center">
                      <Lable lable="Advertisement For:" />
                      <span className="text-gray-600 capitalize">
                        {values.advertisement_for}
                      </span>
                    </div>

                    <div className="flex justify-between items-center mt-2">
                      <Lable lable="Start Date:" />
                      <span className="text-gray-600">
                        {new Date(values.start_date).toLocaleDateString()}
                      </span>
                    </div>

                    <div className="flex justify-between items-center mt-2">
                      <Lable lable="End Date:" />
                      <span className="text-gray-600">
                        {new Date(values.end_date).toLocaleDateString()}
                      </span>
                    </div>
                  </div>

                  {/* Audience Details */}
                  <div className="mt-6 border-t pt-4">
                    <Lable lable="Audience Details" />
                    <div className="grid grid-cols-2 gap-4 mt-2">
                      <div className="flex justify-between">
                        <span>Audience Type:</span>
                        <span className="text-gray-600">
                          {values.audience_type}
                        </span>
                      </div>
                      {values.audience_type === "Own Audience" && (
                        <>
                          <div className="flex justify-between">
                            <span>Age:</span>
                            <span className="text-gray-600">
                              {values.target_audience_age}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span>Location Radius:</span>
                            <span className="text-gray-600">
                              {values.location_radius} KM
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span>Gender:</span>
                            <span className="text-gray-600">
                              {values.gender}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  {/* Cost Calculation */}
                  <div className="mt-6 border-t pt-4">
                    <Lable lable="Cost Calculation" />
                    <div className="grid grid-cols-2 gap-4 mt-2">
                      <div className="flex justify-between">
                        <span>Tax:</span>
                        <span className="text-gray-600">
                          ${values.advertisement_tax}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>Daily Budget:</span>
                        <span className="text-gray-600">
                          ${values.advertisement_budget}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>Total Cost:</span>
                        <span className="text-gray-600">
                          $
                          {values.advertisement_budget +
                            values.advertisement_tax}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Statistics */}
                  <div className="mt-6 border-t pt-4">
                    <Lable lable="Performance" />
                    <div className="flex justify-around mt-4">
                      <div className="text-center">
                        <LuEye className="text-2xl text-green-500" />
                        <p>{values.advertise_views} Views</p>
                      </div>
                      <div className="text-center">
                        <MdDownloadDone className="text-2xl text-blue-500" />
                        <p>{values.ordered_by_advertise} Orders</p>
                      </div>
                      <div className="text-center">
                        <MdOutlineShoppingCart className="text-2xl text-red-500" />
                        <p>{values.addToCart_count} Added to Cart</p>
                      </div>
                      <div className="text-center">
                        <PiShareFat className="text-2xl text-yellow-500" />
                        <p>{values.share} Shares</p>
                      </div>
                    </div>
                  </div>

                  {/* Chart */}
                  <div className="mt-6">
                    <Lable lable="Performance Over Time" />
                    <div className="h-64 mt-4">
                      <Line ref={chartRef} data={data} options={options} />
                    </div>
                  </div>
                </div>
                <ApprovalStatus
                  matchedData={matchedData}
                  waitingForApproval={waitingForApproval}
                />
              </SidebarField>
            </Form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default AdvertisementModal;
